import React from 'react';
import * as S from './styles';
import Carrossel from './Carrossel';

function Home3() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <div>
              <h1>Próximos eventos</h1>
              <p>
                Participe dos nossos próximos encontros e enriqueça sua
                trajetória na psicanálise. Acompanhe nossa agenda e inscreva-se!
              </p>
              {/* <a href="#ver-tudo">VER TUDO</a> */}
            </div>
          </div>
        </S.TextDiv>
        <Carrossel />
      </S.Section>
    </S.Main>
  );
}

export default Home3;
